module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp1_3009.5d636fa0.png";